import { render, staticRenderFns } from "./buyShebei.vue?vue&type=template&id=7fd7d06b&scoped=true&"
import script from "./buyShebei.vue?vue&type=script&lang=js&"
export * from "./buyShebei.vue?vue&type=script&lang=js&"
import style0 from "./buyShebei.vue?vue&type=style&index=0&id=7fd7d06b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd7d06b",
  null
  
)

export default component.exports